import { VIEWING_APPLICANTS_INFO_ITEM_ATTRIBUTE } from './ViewingApplicantsInfoValue.constants'

export function getIsViewingApplicantClickable(applicant) {
  return Boolean(applicant?.can_view) && !applicant?.masked
}

export function toViewingApplicantMultiValue(applicant) {
  return {
    [VIEWING_APPLICANTS_INFO_ITEM_ATTRIBUTE]: applicant.id,
    key: applicant.id,
    user: {
      avatarColor: applicant.avatar_color,
      fullname: applicant.label,
      key: applicant.id,
    },
  }
}

export function getViewingApplicantById({ applicantId, applicants }) {
  return applicants.find(item => String(item.id) === String(applicantId))
}
